import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleLoginSuccess = () => {
  const { search } = useLocation();
  console.log('🚀 ~ GoogleLoginSuccess ~ search:', search);

  useEffect(() => {}, []);

  return <div>Loading</div>;
};

export default GoogleLoginSuccess;
